
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Form, Formik } from "formik";
import { RegisterUserSchema } from "../../utils/validation";
import { registerUser } from "../../redux/Actions/SingleUserActions";
import { useHistory } from "react-router-dom";
import { PropTypes } from "prop-types";
import SignUpText from "./SignUpText";
import SignUpForm1 from "./SignUpForm1";
import { SignUpForm2 } from "./SignUpForm2";
import SignUpForm3 from "./SignUpForm3";
import SignUpForm4 from "./SignUpForm4";

const initialValues = {
  name: "",
  email: "",
  address: "",
  state: "",
  category: "",
  password: "",
  company_logo: "",
  network_manager_email: "",
  network_manager_firstname: "",
  network_manager_lastname: "",
  network_manager_phone: "",
};

const SignUpForm = ({
  isRegistering,
  registerUser,
  registeredSuccess,
  goToPage2,
  goToPage3,
  goToPage4,
  form1,
  form2,
  form3,
}) => {
  const history = useHistory();

  const [state, setState] = useState({
    loaded: false,
    hide: true,
    hidden: true,
    isAllowed: false,
    currentValues: {},
    file_name: "",
    img_url: "",
    error: "",
    captha: ""
  });

  const page2 = () => {
    setState({
      ...state,
      captha: ""
    })
    goToPage2()
  }

  const page3 = () => {
    setState({
      ...state,
      captha: ""
    })
    goToPage3()
  }

  const page4 = () => {
    setState({
      ...state,
      captha: ""
    })
    goToPage4()
  }

  const assignUrl = (result) => {
    setState({
      ...state,
      img_url: result.info.secure_url,
      file_name: result.info.original_filename,
      loaded: true,
      error: "",
    });
  };

  const removeFile = () => {
    setState({
      ...state,
      img_url: "",
      error: "Company logo is required",
      loaded: false,
    });
  };

  const handleClick = () => {
    setState({
      ...state,
      hide: !state.hide,
    });
  };

  const pattern = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,15}$/;

  const handleRegister = callSubmit(state, registerUser, setState);

  useEffect(
    () => {
      if (registeredSuccess) {
        document.getElementById("form").reset();
        setState({
          company_logo: "",
          hidden: true,
          hide: true,
        });
        const values = state.currentValues;
        history.push("/verify-email", values);
      }
    },
    // eslint-disable-next-line
    [registeredSuccess]
  );

  return (
    <div className="sign-up-form">
      <div className="sign-up-form-wrap">
        <div
          className={
            form1 ? "empty" : form2 ? "half" : form3 ? "half2" : "full"
          }
        ></div>
        <SignUpText form1={form1} form2={form2} form3={form3} />

        <div className="sign-up-form-container">
          <Formik
            initialValues={initialValues}
            validationSchema={RegisterUserSchema}
            onSubmit={handleRegister}
          >
            {({ values, isValid, dirty, setFieldValue }) => {
              const block =
                values.email === "" ||
                values.password === "" ||
                !values.password.match(pattern) ||
                !values.email.match(/\S+@\S+\.\S+/);
              const block2 =
                values.name === "" ||
                values.name.length < 2 ||
                values.address === "" ||
                values.address.length > 40 ||
                values.state === "";
              const block3 = values.category === ""
              const block4 =
                !values.network_manager_email.match(/\S+@\S+\.\S+/) ||
                values.network_manager_firstname < 3 ||
                values.network_manager_lastname < 3 ||
                values.network_manager_phone === "";
              return (
                <Form id="form">
                  {form1 ? (
                    <SignUpForm1
                      page2={() => page2()}
                      handleClick={handleClick}
                      hide={state.hide}
                      block={block}
                    />
                  ) : form2 ? (
                    <SignUpForm2
                      setFieldValue={setFieldValue}
                      block2={block2}
                      page3={() => page3()}
                      state={values.state}
                    />
                  ) : form3 ? (
                    <SignUpForm3
                      page2={() => page2()}
                      page4={() => page4()}
                      img_url={state.img_url}
                      block3={block3}
                      error={state.error}
                      loaded={state.loaded}
                      assignUrl={assignUrl}
                      removeFile={removeFile}
                    />
                  ) : (
                    <SignUpForm4
                      page3={() => page3()}
                      isValid={isValid}
                      dirty={dirty}
                      isRegistering={isRegistering}
                      block4={block4}
                      setState={setState}
                      state={state}
                    />
                  )}
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isRegistering: state.singleUser.isRegistering,
    registeredSuccess: state.singleUser.registeredSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  registerUser: (payload) => dispatch(registerUser(payload)),
});

SignUpForm.propTypes = {
  form1: PropTypes.bool,
  form2: PropTypes.bool,
  form3: PropTypes.bool,
  goToPage2: PropTypes.func,
  goToPage3: PropTypes.func,
  goToPage4: PropTypes.func,
  isRegistering: PropTypes.bool,
  registerUser: PropTypes.func,
  registeredSuccess: PropTypes.bool
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpForm);
function callSubmit(state, registerUser, setState) {
  return (value) => {
    const file_url = state.img_url;
    value.company_logo = file_url;
    const newValues = {
      name: value.name,
      email: value.email.trim(),
      address: value.address,
      state: value.state,
      category_id: value.category,
      password: value.password,
      company_logo: value.company_logo,
      network_manager_email: value.network_manager_email,
      network_manager_firstname: value.network_manager_firstname,
      network_manager_lastname: value.network_manager_lastname,
      network_manager_phone: value.network_manager_phone,
    };
    if (state.img_url !== "") {
      submitValues(registerUser, newValues, setState, state);
    } else {
      returnError(setState, state);
    }
  };
}

function returnError(setState, state) {
  setState({
    ...state,
    error: "Company logo is required",
  });
}

function submitValues(registerUser, newValues, setState, state) {
  registerUser(newValues);
  setState({
    ...state,
    currentValues: newValues,
  });
}
